export default "__VITE_ASSET__1311447f__"